import * as React from 'react';
/**
 *
 * Original name: calendar
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=35431%3A9689
 *
 */
export const CalendarFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 5H3.5v2.967H20V5Zm0 4.512H3.5V16.5a2 2 0 0 0 2 2H18a2 2 0 0 0 2-2V9.512ZM9.52 14.776a.754.754 0 1 1-1.507 0 .754.754 0 0 1 1.508 0Zm-.753-2.263a.754.754 0 1 0 0-1.507.754.754 0 0 0 0 1.507Zm3.729-.754a.754.754 0 1 1-1.508 0 .754.754 0 0 1 1.508 0Zm2.27.754a.754.754 0 1 0 0-1.507.754.754 0 0 0 0 1.507Zm-2.246 2.263a.754.754 0 1 1-1.507 0 .754.754 0 0 1 1.507 0Zm2.246.754a.754.754 0 1 0 0-1.508.754.754 0 0 0 0 1.508Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
